<template>
  <TemplateDefault>
    <template #breadcrumbHeader>
      <EventsBreadcrumb />
    </template>

    <template #pageHeading>
      <PageHeadingDefault>
        イベント
      </PageHeadingDefault>
    </template>

    <template #main>
      <EventsMain />
    </template>

    <template #breadcrumbFooter>
      <EventsBreadcrumb />
    </template>
  </TemplateDefault>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import EventsMain from './Main.vue'
import EventsBreadcrumb from './Breadcrumb.vue'
import PageHeadingDefault from '@/components/_core/PageHeadingDefault.vue'

export default defineComponent({
  name: 'EventsApp',

  components: {
    EventsMain,
    EventsBreadcrumb,
    PageHeadingDefault,
  },
})
</script>
